import * as CONSTANTS from '../../constants';
import {store, get} from "../../../services/StorageService";

/**
 * Dismiss the given instruction.
 *
 * @param commit
 * @param payload
 */
export const dismissInstruction = ({commit}, payload) => {
    // Set a dismiss cookie
    store(payload, true);
    commit(CONSTANTS.INSTRUCTION_DISMISS, {page: payload, dismiss: true});
};

/**
 * Get the dismiss status for the given page.
 *
 * @param commit
 * @param payload
 */
export const getDismissStatus = ({commit}, payload) => {
    const dismiss = get(payload);
    commit(CONSTANTS.INSTRUCTION_DISMISS, {page: payload, dismiss: dismiss});
};


// WEBPACK FOOTER //
// ./src/store/modules/instruction/actions.js